import React, { useEffect, useState } from "react";
import { AnimatedTick, Button, Receipt, SidePaneContent, Toast } from "../../../../../../Components";
import { RiDragDropLine } from "react-icons/ri";
import { useClientSettings } from "../../../../../../Hooks/useClientSettings";
import ReceiptDrop from "./drop";
import { apis, post } from "../../../../../../Utils/axios";
import { formatedPrice } from "Utils/utils";

function SubmitReceipt({ dragging, loading, onReload = () => {}, selectedReceipts = [], setSelectedReceipts }) {
	const { isEnabled, currency } = useClientSettings();
	const expenseEnabled = isEnabled("ORGANIZATION") && isEnabled("EXPENSE");

	const [Success, setSuccess] = useState(false);
	const [Loading, setLoading] = useState(false);
	const totalAmount = selectedReceipts.reduce((acc, receipt) => acc + Number(receipt.amount), 0);

	useEffect(() => {
		setSelectedReceipts([]);
	}, [loading]);

	const onReceiptDrop = () => {
		const updatedSelection = selectedReceipts.filter((receipt) => receipt.id !== dragging.id);
		setSelectedReceipts([...updatedSelection, dragging]);
	};

	if (!expenseEnabled) {
		//If expense is not enabled do not show reimbursement side pane
		return null;
	}

	const removeSelection = (id) => {
		setSelectedReceipts(selectedReceipts.filter((receipt) => receipt.id !== id));
	};

	const onSubmit = () => {
		setLoading(true);
		post(apis.submitReceipts, { receipts: selectedReceipts.map((r) => r.id) }, (r, e) => {
			if (r) {
				setSelectedReceipts([]);
				setLoading(false);
				setSuccess(true);
				setTimeout(() => {
					setSuccess(false);
				}, 3000);
				onReload();
			} else if (e) {
				setLoading(false);
				Toast.handleError(e);
			}
		});
	};

	if (selectedReceipts.length) {
		return (
			<SidePaneContent>
				<div className={`flex relative flex-col justify-between w-full h-full bg-light`}>
					<div onDragOver={(e) => e.preventDefault()} onDrop={onReceiptDrop} className="overflow-y-auto flex-grow w-full">
						<div className="sticky top-0 p-2 bg-light">
							<h4>{selectedReceipts.length} Selected</h4>
						</div>
						<div className="flex flex-col gap-2 p-2">
							{selectedReceipts.map((receipt, i) => {
								return <Receipt key={i} {...receipt} onDelete={() => removeSelection(receipt.id)} />;
							})}
						</div>
					</div>
					<div className="flex flex-col gap-2 p-2">
						<div className="p-2 text-white rounded-lg bg-dark">
							<h1 className="mb-2 text-xl">
								Total {currency} {formatedPrice(totalAmount)}
							</h1>
							<Button loading={Loading} onClick={onSubmit} variant="primary" className="w-full">
								Send for Reimbursement
							</Button>
						</div>
					</div>
					<ReceiptDrop dragging={dragging} onDrop={onReceiptDrop} />
				</div>
			</SidePaneContent>
		);
	}

	return (
		<>
			<SidePaneContent>
				<div className="flex relative flex-col gap-2 p-2 w-full h-full">
					<div onDragOver={(e) => e.preventDefault()} onDrop={onReceiptDrop} className="flex-grow w-full">
						{Success ? (
							<div className="w-full h-full flex-center">
								<div>
									<AnimatedTick />
									<h3 className="mt-6">Receipts Submitted</h3>
								</div>
							</div>
						) : (
							<div className={`p-6 w-full h-full text-sm rounded-2xl transition-all flex-center`}>
								<div className="text-center">
									<RiDragDropLine size={52} className="m-auto mb-6" />
									Drag & Drop receipts you want to get reimbursed
								</div>
							</div>
						)}
					</div>
					<div className="flex flex-col gap-2">
						{/* <div className="flex flex-col justify-between p-4 rounded-xl border bg-light">
							<h1 className="text-3xl">{currency} 0</h1>
							<div className="mt-2 text-sm">Expense not submitted</div>
						</div> */}
						{/* <div className="p-4 text-xs text-center">
							<ReceiptStoreCode className="m-auto mb-4" />
							Scan to upload photos to receipt store using your phone
						</div> */}
					</div>
					<ReceiptDrop dragging={dragging} onDrop={onReceiptDrop} />
				</div>
			</SidePaneContent>
		</>
	);
}

export default SubmitReceipt;
